export const getTaxYearRange = (taxYear: string): { start: number; end: number } => {
    const [startStr, endStr] = taxYear.split("/");

    const start = parseInt(startStr, 10);
    const end = parseInt(endStr, 10);

    return { start, end };
};
